import { filter, map } from "rxjs/operators";
import { TypeActionModal } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionOngoingPurchaseSkipProcessDeselect } from "../../ongoing-purchase/actionOngoingPurchase";
export var epicQuickSkipCancel = function (action$, state$, deps) {
    return action$.pipe(filter(function (_a) {
        var type = _a.type, modalId = _a.modalId;
        return (type === TypeActionModal.Close || type === TypeActionModal.CloseLast) &&
            modalId === IdModal.SkipProcess;
    }), map(actionOngoingPurchaseSkipProcessDeselect));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-skip-dialog/epics/epicQuickSkipCancel.ts
// module id = 2113
// module chunks = 3